import { reducer as employeeMoveModal } from './employeeMoveModal'
import { reducer as employeesMoveModal } from './employeesMoveModal'
import { reducer as employeeAddModal } from './employeeAddModal'
import { reducer as employeeTagsModal } from './employeeTagsModal'
import { reducer as selectedEmployee } from './selectedEmployee'
import { reducer as addEmployee } from './addEmployee'
import { reducer as deleteEmployee } from './deleteEmployee'
import { reducer as employeeAssignTag } from './employeeAssignTag'
import { reducer as employeeRemoveTag } from './employeeRemoveTag'
import { reducer as getAllEmployees } from './getAllEmployees'
import { reducer as deleteEmployeeList } from './deleteEmployeeList'
import { reducer as updateEmployee } from './updateEmployee'
import { reducer as addEmployeeWithManager } from './addEmployeeWithManager'
import { reducer as removeEmployeesFromTag } from './removeEmployeesFromTag'
import { reducer as uploadEmployees } from './uploadEmployees'
import { reducer as uploadEmployeesAppend } from './uploadEmployeesAppend'
import { reducer as employeesExportExcel } from './employeesExportExcel'
import { reducer as getUnassignedEmployees } from './getUnassignedEmployees'
import { reducer as getAssignedEmployees } from './getAssignedEmployees'
import { reducer as employeeAssignModal } from './employeeAssignModal'

export default {
  employeeMoveModal,
  employeesMoveModal,
  employeeAddModal,
  employeeTagsModal,
  selectedEmployee,
  addEmployee,
  deleteEmployee,
  employeeAssignTag,
  employeeRemoveTag,
  getAllEmployees,
  deleteEmployeeList,
  updateEmployee,
  addEmployeeWithManager,
  removeEmployeesFromTag,
  uploadEmployees,
  employeesExportExcel,
  getUnassignedEmployees,
  getAssignedEmployees,
  employeeAssignModal,
  uploadEmployeesAppend
}



// WEBPACK FOOTER //
// ./src/store/employee/index.js